import { Browser } from '@capacitor/browser';
import history from '@history';

import { logger } from 'utils/logger';
import { getIsNativePlatform } from 'utils/platform';

import {
  NATIVE_APP_SCHEME,
  NATIVE_SSO_CALLBACK_HOST,
  NATIVE_SSO_TOKEN_KEY_PARAM,
  PATH_SSO_LOGIN_RELATIVE,
} from './native.constants';

export const openSsoInBrowser = async ssoUrl => {
  await Browser.open({ url: ssoUrl, presentationStyle: 'fullscreen' });
};

export const getIsSsoCallbackUrl = url => {
  if (!url) {
    return false;
  }

  return url.startsWith(`${NATIVE_APP_SCHEME}://${NATIVE_SSO_CALLBACK_HOST}`);
};

export const getSsoTokenKeyFromCallback = url => {
  const queryIndex = url.indexOf('?');

  if (queryIndex === -1) {
    return null;
  }

  const searchParams = new URLSearchParams(url.slice(queryIndex + 1));

  return searchParams.get(NATIVE_SSO_TOKEN_KEY_PARAM);
};

const completeSsoCallback = async url => {
  await Browser.close().catch(() => null);

  const ssoTokenKey = getSsoTokenKeyFromCallback(url);

  if (!ssoTokenKey) {
    logger.error('SSO deep-link callback missing ssoTokenKey');

    return;
  }

  history.push(`${PATH_SSO_LOGIN_RELATIVE}?${NATIVE_SSO_TOKEN_KEY_PARAM}=${ssoTokenKey}`);
};

export const registerSsoDeepLinkListener = async () => {
  if (!getIsNativePlatform()) {
    return null;
  }

  const { App } = await import('@capacitor/app');

  return App.addListener('appUrlOpen', ({ url }) => {
    if (getIsSsoCallbackUrl(url)) {
      completeSsoCallback(url);
    }
  });
};
